module.exports = __webpack_public_path__ + "img/flag_238.91826984.png";